<template>
  <div class="subscription-popup-component"
  >
    <span id="text">{{ value }}</span>
    <span class="copy-btn"
          @click="handleWxQrCodePopup"
    >添加</span>
    <qr-code-popup :show.sync="showWxQrCodePopup"
                   :src="require('@/assets/img/default/ser_qr_code.png')"
                   :hint="hint"
    />
  </div>
</template>

<script>
  import QrCodePopup from '@/components/QrCodePopup';

  export default {
    name: 'FollowSubscription',
    components: {
      QrCodePopup,
    },
    data() {
      return {
        showWxQrCodePopup: false,
        hint: '关注公众号<br>即可收到最新资讯',
      };
    },
    props: {
      value: {
        type: String,
        required: true,
      },
    },
    methods: {
      handleWxQrCodePopup() {
        this.showWxQrCodePopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .subscription-popup-component {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  #text {
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .copy-btn {
    margin-left: @size-small;
    width: 68px;
    height: 26px;
    line-height: 26px;
    color: @color-primary;
    font-size: @font-size-extra-extra-small;
    text-align: center;
    border-radius: @border-radius-base;
    border: @border-width-base @border-style-base @color-primary
  }
</style>
